import {GroupMembership, TourMembership} from "./membership";

export interface Account {
    id: number;
    email: string;
    username: string;
    firstName: string;
    lastName: string;
    accountCode: string;
    shareData: boolean;

    tours?: TourMembership[];
    groups?: GroupMembership[];
}

export interface AccountCreateDTO {
    email: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
}

export interface AccountUpdateDTO {
    email?: string;
    username?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
}

export enum UserRole {
    APPLIED = "APPLIED",
    MEMBER = "MEMBER",
    ADMIN = "ADMIN",
    CREATOR = "CREATOR"
}